import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import logoImage from './images/logo.jpg';
import psdfimage from './images/psdfimage.png';
import html2canvas from "html2canvas";
import TablePagination from '@mui/material/TablePagination';

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export default class Vendor1099Report extends Component {
    constructor(props) {
        super(props);

        
    const currentYear = dayjs().year();
    const years = [];
    for (let i = 2020; i <= currentYear; i++) {
        years.push(i);
    }

        let initialSelectedYear = currentYear;

        this.state = {
            redirect: false,
            ReportData: [],
            orderBy: '',
            order: 'asc',
            periods: [],exportdata:[],
            selectedPeriod: '',
            summarizeRetainedEarnings: false,
            hideZeroBalance: true,
            openExportDialog: false,
            years: years,
            selectedYear: initialSelectedYear,pdflogo:'',
			 years: years,
        selectedYear: currentYear < 2020 ? 2020 : currentYear,totaldata:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
        };

      

         this.contentRef = React.createRef();
    }

    componentDidMount() {
        document.title = "1099 Vendor Report";
         this.apicall(this.state.page,this.state.rowsPerPage)
		   this.props.parentdasCallback(
            "1099 Vendor Report"
        ); 
		 ;this.fetchBusinessSettings();
    }

    handleClickSearch = () => {
        this.apicall(this.state.page,this.state.rowsPerPage)
    }

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

    handleYearChange = (event) => {
        this.setState({ selectedYear: parseInt(event.target.value, 10) }); // Convert to number
    }
	
	apicall(page,rowsPerPage){
		
    const { selectedYear, businessSettings } = this.state;

    if (!businessSettings) return; 

  
    const accountsStartDate = businessSettings["Accounts Start Date"]; 
    const yearEndDate = businessSettings["Year End Date"]; 

  
    const fromMonthDay = accountsStartDate ? accountsStartDate.substring(5) : "01-01";
    const toMonthDay = yearEndDate ? yearEndDate.substring(5) : "12-31";

  
    const v_fromyear = `${selectedYear}-${fromMonthDay}`;
    const v_toyear = `${selectedYear + 1}-${toMonthDay}`;

   

axios.get(
    localStorage.getItem('ISIurl') + 
    'ajaxreports.php?action=vendorreportgetall&fromyear=' + v_fromyear +
    '&toyear=' + v_toyear +
    '&cmp_id=' + localStorage.getItem('ISIcmpid')+'&StartIndex='+page+'&PageSize='+rowsPerPage
)
        .then(resp => {
          
           if(resp.data.length>0)
		   {
          

            this.setState({ ReportData: resp.data,
			
			
			 totaldata:parseInt(resp.data[0].total_count),
			});
			this.Exportvendorapicall();
			
		   }else{
			    this.setState({ ReportData: [],totaldata:0,exportdata:[] });
		   }
        })
        .catch(error => {
         
           
        });
};


Exportvendorapicall(){
		
    const { selectedYear, businessSettings } = this.state;

    if (!businessSettings) return; 

  
    const accountsStartDate = businessSettings["Accounts Start Date"]; 
    const yearEndDate = businessSettings["Year End Date"]; 

  
    const fromMonthDay = accountsStartDate ? accountsStartDate.substring(5) : "01-01";
    const toMonthDay = yearEndDate ? yearEndDate.substring(5) : "12-31";

  
    const v_fromyear = `${selectedYear}-${fromMonthDay}`;
    const v_toyear = `${selectedYear + 1}-${toMonthDay}`;

   

axios.get(
    localStorage.getItem('ISIurl') + 
    'ajaxreports.php?action=vendorreportgetall&fromyear=' + v_fromyear +
    '&toyear=' + v_toyear +
    '&cmp_id=' + localStorage.getItem('ISIcmpid')
)
        .then(resp => {
          
           if(resp.data.length>0)
		   {
          

            this.setState({ exportdata: resp.data,
			
			
			 totaldata:parseInt(resp.data[0].total_count),
			});
			
		   }else{
			    this.setState({ exportdata: [],totaldata:0 });
		   }
        })
        .catch(error => {
         
           
        });
};

  handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
} 
	


  handleDownload = () => {
        const { exportdata, selectedYear } = this.state;
        const doc = new jsPDF();

        const imgWidth = 40;
        const imgHeight = 20;
        const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
        const imgY = 10;
		
       if (this.state.pdflogo) {
			 const logoImage = this.state.pdflogo.startsWith('data:image')
			  ? this.state.pdflogo
			  : `data:image/jpeg;base64,${this.state.pdflogo}`;
		  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
	 }
  

        const title = `1099 Vendor Report - ${selectedYear}`;
        doc.setFontSize(16);

        const titleY = imgY + imgHeight + 8;

        doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
        const tableStartY = titleY + 10;

        const headers = [
            ['Business Name', 'Address', 'Vendor Tax ID', 'Net Payments'] // Updated header
        ];

        const rows = exportdata.map(item => {
            return [
                item.ve_businessname,
                item.ve_billingaddress1,
                item.ve_tax_id,
                item.net_payments || '0.00', // Use net_payments
            ];
        });

        doc.autoTable({
            head: headers,
            body: rows,
            startY: tableStartY,
            theme: 'striped',
            didDrawPage: function (data) {
                var str = "Page " + doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(str, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
            }
        });

        doc.save(`1099VendorReport_${selectedYear}.pdf`);
        this.handleCloseExportDialog();
    };

   


fetchBusinessSettings = () => {
    axios.get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php?action=getall&bs_page=4&bs_id=1,3&bs_cmp_id=${localStorage.getItem("ISIcmpid")}`)
        .then(resp => {
            if (Array.isArray(resp.data)) {
                const settings = {};
                resp.data.forEach(item => {
                    if (item.bs_title && item.bs_value) {
                        settings[item.bs_title] = item.bs_value; 
                    }
                });
                this.setState({ businessSettings: settings });
            }
        });
}



  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };  
  
 handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
   render() {
        if (this.state.redirect === true) {
            return <Navigate to={this.state.pagename} />;
        }

        const { ReportData, selectedYear, years,exportdata } = this.state;
        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul style={{ margins: '0px 10%' }}>
                       

					   <li>
                            <p>Calendar Year</p>

                            <select
                                id="calendarYearSelect"
                                className="txtbox"
                                value={selectedYear}
                                onChange={this.handleYearChange}
								className="txtbox"
                                style={{ width: '200px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
                            >
                                {years.map(year => (
                                    <option key={year} value={year}>
                                        {year} Calendar Year
                                    </option>
                                ))}
                            </select>
                        </li>
						
						
						
                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Calculate
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog}
                                >
                                    EXPORT
                                </Button>
                            </p>
                        </li>
                    </ul>
                    <div className="clear"></div>
                </div>

                <div className="estimatebox">
                    <Paper>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table"  style={{ paddings: '0px 4%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Business Name</TableCell>
                                        <TableCell>Address</TableCell>
                                        <TableCell align="right">Vendor Tax ID</TableCell>
                                        <TableCell align="right">Net Payments</TableCell> {/* Updated header */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ReportData.length > 0 ? (
                                        ReportData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.ve_businessname}</TableCell>
                                                <TableCell>{row.ve_billingaddress1}</TableCell>
                                                <TableCell align="right">{row.ve_1099taxcode}</TableCell>
                                                <TableCell align="right">{row.amount_paid || '0.00'}</TableCell> {/* Use net_payments */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={4}>No Records</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
						
						
						 <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />  
						
						
						
						
						
                    </Paper>
                </div>
<div className="estimatebox" style={{"display":"none"}}>
                    <Paper>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table" id="1099vendor-report-table" style={{ paddings: '0px 4%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Business Name</TableCell>
                                        <TableCell>Address</TableCell>
                                        <TableCell align="right">Vendor Tax ID</TableCell>
                                        <TableCell align="right">Net Payments</TableCell> {/* Updated header */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ReportData.length > 0 ? (
                                        ReportData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.ve_businessname}</TableCell>
                                                <TableCell>{row.ve_billingaddress1}</TableCell>
                                                <TableCell align="right">{row.ve_1099taxcode}</TableCell>
                                                <TableCell align="right">{row.amount_paid || '0.00'}</TableCell> {/* Use net_payments */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={4}>No Records</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
						
						
						
						
						
						
                    </Paper>
                </div>
                <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generate 1099 Vendor Report</DialogTitle>

                    <DialogContent>
                        <p>To generate a new report, based on the latest selection criteria you've specified, choose the format
                            you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>

                          <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
						
						<ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="my-custom-excel-button" 
                            table="1099vendor-report-table"
                            filename={`1099VendorReport_${selectedYear}`}
                            sheet="1099 Vendor Report"
                            buttonText=""
                        />
                        <img
						src={psdfimage}
						width={100}
						height={100}
						style={{ cursor: "pointer" }}
						 onClick={this.handleClickOpen} 
						alt="Download PDF"
					  />
						
						</p>
						
						
									
					
						
						
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
				
				
				
				
				
				
				
				
				
				
				
				
				
	
<div ref={this.contentRef}
  style={{ position: "absolute", top: "-10000px",left: "-10000px",width: "210mm",backgroundColor: "#fff", opacity: 1,}}
>

<div style={{ textAlign: "center", padding: "20px" }}>


<img
  style={{ width: "200px", height: "100px" }}
  src={this.state.pdflogo} 
  alt="Company Logo"
/>

    <h2>1099 Vendor Report</h2>

 <Paper>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table" id="1099vendor-report-table" style={{ paddings: '0px 4%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Business Name</TableCell>
                                        <TableCell>Address</TableCell>
                                        <TableCell align="right">Vendor Tax ID</TableCell>
                                        <TableCell align="right">Net Payments</TableCell> {/* Updated header */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ReportData.length > 0 ? (
                                        ReportData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.ve_businessname}</TableCell>
                                                <TableCell>{row.ve_billingaddress1}</TableCell>
                                                <TableCell align="right">{row.ve_1099taxcode}</TableCell>
                                                <TableCell align="right">{row.net_payments || '0.00'}</TableCell> {/* Use net_payments */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={4}>No Records</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
  </div>
</div>
	
</React.Fragment>
        );
    }
}